import { createApi } from "@reduxjs/toolkit/query/react";
import { defaultBaseQuery } from "../../utils/API/fetchBaseQuery";
import { transformRequest } from "../../utils/API/requestMiddleware";
import { transformErrorResponse, transformSuccessResponse } from "../../utils/API/responseMiddleware";

const liabilityTypesAPI = createApi({
    reducerPath: 'liabilityTypesAPI',
    baseQuery: defaultBaseQuery,
    endpoints: (builder) => ({

        addLiabilityTypes: builder.mutation({
            query: (data) => ({
                url: `/LiabilityTypes/AddLiabilityTypes`,
                method: `POST`,
                body: transformRequest(data)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        updateLiabilityTypes: builder.mutation({
            query: (data) => ({
                url: `/LiabilityTypes/UpdateLiabilityTypes`,
                method: `POST`,
                body: transformRequest(data)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        getLiabilityTypesList: builder.mutation({
            query: (data) => ({
                url: `/LiabilityTypes/GetLiabilityType`,
                method: `POST`,
                body: transformRequest(data)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        getLiabilityTypeById: builder.query({
            query: (data) => ({
                url: `/LiabilityTypes/GetLiabilityTypeById?id=${data}`,
                method: `GET`,
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        deleteLiabilityType: builder.mutation({
            query: (data) => ({
                url: `/LiabilityTypes/DeleteLiabilityTypes?LiabilityType=${data.liabilityType}&MergeFieldPrefix=${data.mergeFieldPrefix}`,
                method: `DELETE`,
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        getLiabilityBasicTypeById: builder.query({
            query: (Id) => ({
                url: `/LiabilityTypes/GetLiabilityBasicTypeById?Id=${Id}`,
                method: `GET`,
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        getUnassignedLiabilityBasic: builder.query({
            query: (Id) => ({
                url: `/LiabilityTypes/GetUnassignedBasicDetailsById?LiabilityTypeId=${Id}`,
                method: `GET`,
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        getAssignedLiabilityBasic: builder.query({
            query: (Id) => ({
                url: `/LiabilityTypes/GetassignedLiabilityBasic?LiabilityTypeId=${Id}`,
                method: `GET`,
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        unassignedLiabilityBasic: builder.mutation({
            query: (data) => ({
                url: `/LiabilityTypes/UnAssignLiabilityBasic?liabilitytypeid=${data.liabilitytypeid}&basistypeid=${data.basistypeid}`,
                method: `DELETE`,
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        assignedLiabilityBasic: builder.mutation({
            query: (data) => ({
                url: `/LiabilityTypes/AssignLiabilityBasic`,
                method: `POST`,
                body: transformRequest(data)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),

    })
})

export const {
    useAddLiabilityTypesMutation,
    useUpdateLiabilityTypesMutation,
    useGetLiabilityTypesListMutation,
    useLazyGetLiabilityTypeByIdQuery,
    useDeleteLiabilityTypeMutation,
    useLazyGetLiabilityBasicTypeByIdQuery,
    useLazyGetUnassignedLiabilityBasicQuery,
    useLazyGetAssignedLiabilityBasicQuery,
    useUnassignedLiabilityBasicMutation,
    useAssignedLiabilityBasicMutation
} = liabilityTypesAPI;
export default liabilityTypesAPI;